import { useState, useEffect } from 'react';
import { REST_API_BASE_URL } from '../services/apiConfig';

export const useOnlinePlayerCount = () => {
    const [onlinePlayers, setOnlinePlayers] = useState<number>(0);
    
    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await fetch(`${REST_API_BASE_URL}/players/count`);
    
                if (!response.ok) {
                    console.error('Server response:', response.status, response.statusText);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const count = await response.json();
                setOnlinePlayers(count);                
            } catch (error) {
                console.error('Error fetching online player number:', error);
                throw error;
            }
        }

        fetchCount();
        console.log("useOnlinePlayerCount: Fetching online player count");
        const interval = setInterval(fetchCount, 100);
        return () => clearInterval(interval);

    }, []);

    return onlinePlayers;
};
